module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-2-79256e2107755cfe33c67c6f14e37013.jpg";